import Fetcher from './fetcher';
import Uploader from './uploader';

const fetcher = new Fetcher({ urlPrefix: '/backend/' });
export { Uploader, fetcher };
